import { css } from 'styled-components';

import { theme } from '../../ui/theme';

export const sidebarMenuItemStyles = css`
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${theme.space[4]};
    padding: ${theme.space[4]} ${theme.space[8]};
    border-radius: ${theme.radii[4]};

    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.foreground.default};
        background-color: ${theme.colors.background.inset};
        text-decoration: none;
    }
`;
